import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LockKey } from "@phosphor-icons/react";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const forced = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      setUser(r.data.user);
      toast.success("Password updated");
      navigate(r.data.user.role === "employee" ? "/employee" : "/admin", { replace: true });
    } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="change-password-page">
      <div className="w-full max-w-sm bg-white border border-stone-200 rounded-2xl p-6 space-y-5">
        <div className="text-center space-y-2">
          <div className="w-12 h-12 mx-auto rounded-full bg-accent flex items-center justify-center"><LockKey size={24} weight="duotone" className="text-primary" /></div>
          <h1 className="font-heading text-xl font-extrabold">{forced ? "Set your own password" : "Change password"}</h1>
          <p className="text-sm text-stone-500">
            {forced ? "For security, please replace the password given to you before continuing." : "Choose a new password for your account."}
          </p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          {[["current", "Current password"], ["next", "New password (min 8 chars, letter + number)"], ["confirm", "Confirm new password"]].map(([k, label]) => (
            <div key={k}>
              <label className="text-sm font-semibold text-stone-700">{label}</label>
              <input type="password" required value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                data-testid={`change-password-${k}`}
                className="mt-1 w-full min-h-[48px] px-4 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
            </div>
          ))}
          <button type="submit" disabled={busy} data-testid="change-password-submit"
            className="tap-scale w-full min-h-[52px] rounded-full bg-primary text-white font-bold hover:bg-[#A63F07] transition-colors duration-200 disabled:opacity-60">
            {busy ? "Updating…" : "Update password"}
          </button>
          {!forced && (
            <button type="button" onClick={() => navigate(-1)} data-testid="change-password-back"
              className="w-full text-sm font-semibold text-stone-500 hover:text-primary transition-colors duration-200">Cancel</button>
          )}
        </form>
      </div>
    </div>
  );
}
